import { useState } from 'react';

import { Trans } from '@lingui/react/macro';

import { SectionCardWithHeader } from './common/SectionCardWithHeader';
import { DentalCareSection } from './DentalCareSection';
import { OrthodonticsSection } from './OrthodonticsSection';

export const PlanSummarySection = () => {
  const [selectedTab, setSelectedTab] = useState('dental-care');

  const tabs = [
    {
      id: 'dental-care',
      label: 'Dental Care',
      isSelected: selectedTab === 'dental-care',
    },
    {
      id: 'orthodontics',
      label: 'Orthodontics',
      isSelected: selectedTab === 'orthodontics',
    },
  ];

  const handleTabChange = (tabId: string) => {
    setSelectedTab(tabId);
  };

  const renderContent = () => {
    switch (selectedTab) {
      case 'dental-care':
        return <DentalCareSection />;
      case 'orthodontics':
        return <OrthodonticsSection />;
      default:
        return (
          <div className="vai-flex vai-items-center vai-justify-center vai-h-32">
            <div className="vai-text-gray-400 vai-text-sm">
              <Trans>Please select a tab to view benefits</Trans>
            </div>
          </div>
        );
    }
  };

  return (
    <div id="plan-summary-section" className="vai-mb-8">
      <SectionCardWithHeader
        title="Plan Summary"
        tabs={tabs}
        onTabChange={handleTabChange}
        className="vai-w-full"
      >
        {renderContent()}
      </SectionCardWithHeader>
    </div>
  );
};
